import React from "react";

import svg from "../../assets/images/icons/gray_description.svg";

export const DescriptionGrayIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Description"}
    />
);
